var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1256 285L1256 313",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1256.5,
    cy: 280.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1253.1 289C1252.64 289 1252.24 288.834 1251.9 288.501C1251.57 288.168 1251.4 287.767 1251.4 287.3C1251.4 286.833 1251.57 286.432 1251.9 286.099C1252.24 285.766 1252.64 285.6 1253.1 285.6C1253.57 285.6 1253.97 285.766 1254.31 286.099C1254.64 286.432 1254.81 286.833 1254.81 287.3C1254.81 287.767 1254.64 288.168 1254.31 288.501C1253.97 288.834 1253.57 289 1253.1 289ZM1261.61 289C1261.14 289 1260.74 288.834 1260.41 288.501C1260.08 288.168 1259.91 287.767 1259.91 287.3C1259.91 286.833 1260.08 286.432 1260.41 286.099C1260.74 285.766 1261.14 285.6 1261.61 285.6C1262.08 285.6 1262.48 285.766 1262.81 286.099C1263.15 286.432 1263.31 286.833 1263.31 287.3C1263.31 287.767 1263.15 288.168 1262.81 288.501C1262.48 288.834 1262.08 289 1261.61 289ZM1252.38 275.4L1254.42 279.65H1260.38L1262.72 275.4H1252.38ZM1251.57 273.7H1264.12C1264.45 273.7 1264.7 273.845 1264.87 274.136C1265.04 274.426 1265.04 274.72 1264.89 275.018L1261.87 280.457C1261.71 280.741 1261.5 280.96 1261.24 281.116C1260.98 281.272 1260.69 281.35 1260.38 281.35H1254.04L1253.1 283.05H1263.31V284.75H1253.1C1252.47 284.75 1251.98 284.47 1251.66 283.911C1251.33 283.351 1251.32 282.795 1251.62 282.243L1252.76 280.16L1249.7 273.7H1248V272H1250.77L1251.57 273.7Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping1);
export default __webpack_public_path__ + "static/media/shopping_1.83dcf09c7e9d4de89619304924c5100a.svg";
export { ForwardRef as ReactComponent };